/*
   legalDetails.js  —  the facts the legal pages depend on

   Every value still wrapped in [[ ]] is a placeholder that has to be filled in
   (and checked by whoever signs off the policy) before these pages go live.
   They are collected here so each fact is written once: the privacy policy,
   the terms and the deletion page all read from this file, and <Fact> renders
   any value that is still a placeholder highlighted so it cannot be missed.
*/

export const LEGAL = {
  companyName:   'Thoreau Consulting (Pty) Ltd',
  productName:   'Pulso',
  regNumber:     '2005/014998/07',
  address:       '21 Limpopo Road, Randburg, Gauteng, South Africa, 2195',
  contactEmail:  'pulso@thoreau.co.za',

  // Pulso is branded "by Imaginarium". Meta (and anyone else) needs to see
  // that the brand and the site belong to the company above.
  brandName:     'Imaginarium (IMGNRM)',
  brandUrl:      'https://imgnrm.com',
  siteDomain:    'pulso.imgnrm.com',

  informationOfficerEmails: ['zak.wood@thoreau.co.za', 'grace.vantonder@thoreau.co.za'],

  lastUpdated:   '1 October 2026',

  backupRetentionPeriod:      '60 days',
  postAgreementDeletionPeriod: '60 days',
  deletionTimeframe:          '30 days',

  databaseProvider:    'MongoDB Atlas',
  dataStorageLocation: 'Cape Town, South Africa',

  liabilityCap:       '1x your annual fees paid',
  termsNoticePeriod:  "30 days'",
};

export const isPlaceholder = (value) => typeof value === 'string' && value.startsWith('[[');
